module.exports = __webpack_public_path__ + "static/media/card-helvaci.e5a1bf41.png";